import { useGlobalStore } from '@highlight/ipc/react'
import {
  DEFAULT_SIDEPANEL_BACKGROUND_BLUR_ENABLED,
  isSidepanelBackgroundBlurEnabled,
  SIDEPANEL_BACKGROUND_BLUR_SETTING_KEY,
} from '@shared/sidepanel/background-blur'

/**
 * The panel's translucency, as one class both surfaces share.
 *
 * Home and an open View are the same surface to the eye, but a View paints
 * *over* Home — so two translucent layers composite and the View reads heavier
 * than Home behind it. The higher the alpha, the smaller that gap: at /95 the
 * composite is within a hair of the base, which is why this isn't /90.
 *
 * Translucent rather than blurred: the native window blur is applied behind the
 * panel by the main process, so there's no web backdrop-filter to speak of.
 *
 * Scoped to the overlay: a popout has no Home to cover, and the native window
 * vibrancy is its surface.
 */
export function useSidepanelSurfaceBackground(): string {
  const [backgroundBlurEnabled] = useGlobalStore<boolean>(
    'settings',
    SIDEPANEL_BACKGROUND_BLUR_SETTING_KEY,
    DEFAULT_SIDEPANEL_BACKGROUND_BLUR_ENABLED,
  )

  return isSidepanelBackgroundBlurEnabled(backgroundBlurEnabled) ? 'overlay:bg-background/95' : 'overlay:bg-background'
}
